import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const uploadZipArchive = async (file: File, contentId?: string) => {
  try {
    const res = contentId
      ? await portalGatewayClient.table.uploadTableZipArchive(contentId, {
          file,
        })
      : await portalGatewayClient.tenant.uploadZipArchive({ file });

    if (res?.data) {
      return res.data;
    }
    return res.error;
  } catch (e) {
    console.error('Error uploading zip archive:', e);
    throw e instanceof Error ? e : new Error('Unexpected error');
  }
};

function removeEmptyValues(
  metadata: Record<string, unknown>
): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const key in metadata) {
    const entry = metadata[key];
    if (entry == null || (Array.isArray(entry) && entry.length === 0)) {
      continue;
    }
    result[key] = entry;
  }

  return result;
}

export const uploadDocument = async (
  file: File,
  contentId: string,
  metadata: Record<string, unknown>
) => {
  try {
    const response = await portalGatewayClient.table.uploadTableDocument(
      contentId,
      {
        file,
        metadata: removeEmptyValues(metadata),
      }
    );

    if (!response.ok) {
      throw new HttpError(
        extractErrorMessage(response.error, `Error uploading document`),
        response
      );
    }
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
};
